import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(({ palette, spacing, typography, breakpoints }) => ({
  cta: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '340px',
    padding: spacing(4),
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      minWidth: '100%',
      alignItems: 'center',
      textAlign: 'center',
      padding: spacing(1),
      '@media (orientation: landscape)': {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        textAlign: 'left',
        gap: spacing(2)
      }
    }
  },
  ctaCallout: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    justifyContent: 'space-around',
    [breakpoints.down('md')]: {
      alignItems: 'center'
    }
  },
  ctaTitle: {
    width: '75%',
    marginBottom: spacing(2.5),
    [breakpoints.down('lg')]: {
      fontSize: '1.75rem',
      marginBottom: spacing(1.5)
    },
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      minWidth: '100%',
      fontWeight: 500,
      fontSize: '2rem',
      '@media (orientation: landscape)': {
        fontSize: '1.4rem',
        lineHeight: '1.2rem',
        marginBottom: spacing(1)
      }
    }
  },
  ctaPrice: {
    fontSize: '1.5rem',
    fontWeight: 400,
    marginBottom: spacing(3)
  },
  ctaPriceMobile: {
    marginBottom: spacing(3),
    '@media (orientation: landscape)': {
      fontSize: '1.2rem',
      lineHeight: '1.1rem',
      marginBottom: spacing(0)
    }
  },
  ctaSign: {
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      '@media (orientation: landscape)': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  },
  ctaSignIn: {
    fontSize: '1.2rem',
    marginTop: spacing(3),
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      marginTop: spacing(1),
      '@media (orientation: landscape)': {
        fontSize: '1rem'
      }
    }
  },
  ctaLink: {
    color: palette.common.white
  },
  ctaButton: {
    backgroundColor: palette.common.black,
    color: palette.primary.white,
    fontWeight: typography.fontWeightBold,
    padding: spacing(1, 4),
    borderRadius: '8px',
    textDecoration: 'none',
    minWidth: '200px',
    minHeight: '50px',
    // The Exclusive Content Paywall requires a different breakpoint for mobile
    // Any changes to this value should also be reflected in the index.js file
    '@media (max-width: 967px)': {
      minWidth: '300px',
      '@media (orientation: landscape)': {
        minWidth: '240px'
      }
    }
  }
}))
